// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__j05r_","bold":"styles_bold__HN4Dc","icon":"styles_icon__1zsMZ"};